var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m287.5 472.1476-7.5-6.471667v8.324067h15v-8.324067zm.00075-1.952133-7.50075-6.476067v-.7194h15v.7194z","fill":"#3958df","fillRule":"evenodd","transform":"translate(-280 -463)"}));
}

Email.defaultProps = {"height":"11","viewBox":"0 0 15 11","width":"15"};

module.exports = Email;

Email.default = Email;
